import './consoleSilence';
import { installMonacoCancellationFilter } from './utils/monacoCancellationFilter';
import './firebase/guestAuthPrefetch';

installMonacoCancellationFilter();
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import ReactGA from 'react-ga4';
import './styles/main.css';
import App from './App';
import { captureCampaignAttribution } from './utils/campaignAttribution';

// GA4 — same Measurement ID as the marketing landing page so app + landing
// page sessions roll up into a single property.
const GA_MEASUREMENT_ID =
  process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-SLZP48H5XB';
if (GA_MEASUREMENT_ID) {
  ReactGA.initialize(GA_MEASUREMENT_ID, {
    testMode: process.env.NODE_ENV !== 'production',
  });
}

captureCampaignAttribution();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
